import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/pages/home';
import About from '@/views/pages/about';
import Corp from '@/views/pages/corp';
import Head from './components/header.vue';

Vue.use(Router)

export default new Router({
  routes: [
    { path: '/', component: Home },
    { path: '/index', component: Home },
    { path: '/about', component: About },
    { path: '/corp', component: Corp },
    { path: '/head', component: Head },
    // path: '*',component: 404
  ]
})
